import _ from 'lodash';


/* @ngInject */
export default function PermissionsDirective(UserInfoService, $compile) {
  return {
    restrict: 'A',
    priority: 2000,
    compile(elem, attr) {
      let action = () => { /**/ };

      const permissions = UserInfoService.getUserPermissions();
      const componentPermissionKey = attr.permissions;
      const permLevel = _.get(permissions, componentPermissionKey);
      if (permLevel === 'disable') {
        action = (scope, element) => {
          attr.$set('disabled', '');
          elem.css({
            cursor: 'not-allowed'
          });
          elem
            .addClass('no-permissions')
            .removeAttr('ng-click')
            .removeAttr('ng-keyup')
            .removeAttr('ng-change')
            .removeAttr('ng-touchstart')
            .removeAttr('ng-touchend')
            .removeAttr('permissions');
          elem.off();
          $compile(element)(scope);
        };
      }
      if (permLevel === 'destroy') {
        action = (__, element) => {
          element.remove();
        };
      }
      return {
        post(scope, element) {
          action(scope, element);
        }
      };
    }
  };
}
